// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-sider {
  height: 100vh;
  position: sticky;
  top: 0;
  padding-bottom: 1.5rem;
  transition: 0.3s;
  overflow-y: auto;
  overflow-x: hidden;
}
.menu-sider.hidden {
  pointer-events: none;
  opacity: 0;
}
.menu-sider .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.menu-sider .menu-sider-button-icon {
  transition: 0.6s;
}
.menu-sider .menu-sider-button-icon.expand-icon {
  transform: rotateY(180deg);
}
.menu-sider .partner-logo-container {
  opacity: 1;
  animation: opacity_entry 0.3s 1;
  display: flex;
  align-items: end;
}
.menu-sider .partner-logo-container .header-powered-by {
  margin-left: 0.3rem;
}
.menu-sider img {
  opacity: 1;
  animation: opacity_entry 0.3s 1;
}
.menu-sider .menu-sider-container .menu-item-container {
  display: flex;
  align-items: center;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0.2rem 0.8rem;
  transition: 0.3s;
  border-radius: 0.5rem;
  cursor: pointer;
}
.menu-sider .menu-sider-container .menu-item-container .menu-item-icon-container {
  margin-right: 0.5rem;
  font-size: 1.2rem;
  color: #000000;
  transition: 0.3s;
}
.menu-sider .menu-sider-container .menu-item-container .menu-item-label {
  font-weight: 500;
  color: #000000;
  transition: 0.3s;
  opacity: 1;
  animation: opacity_entry 0.3s 1;
}
.menu-sider .menu-sider-container .menu-item-container:hover {
  background-color: #f2f2f2;
}
.menu-sider .menu-sider-container .menu-item-container:hover .menu-item-icon-container {
  color: var(--primary-button-color);
}
.menu-sider .menu-sider-container .menu-item-container:hover .menu-item-label {
  color: var(--primary-button-color);
}
.menu-sider .menu-sider-container .menu-item-container.active {
  background-color: var(--primary-button-color);
}
.menu-sider .menu-sider-container .menu-item-container.active .menu-item-icon-container {
  color: var(--primary-button-text-color);
}
.menu-sider .menu-sider-container .menu-item-container.active .menu-item-label {
  color: var(--primary-button-text-color);
}
.menu-sider .menu-sider-container .menu-sider-divider {
  margin: 1rem 0;
}
.menu-sider .menu-sider-user-container {
  cursor: default;
}
.menu-sider .menu-sider-user-container .user-infos {
  opacity: 1;
  animation: opacity_entry 0.3s 1;
}
.menu-sider .menu-sider-user-container .user-infos .user-name {
  font-weight: 500;
  line-height: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.menu-sider .menu-sider-user-container .user-infos .user-business-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #c9d3cc;
}
.menu-sider::-webkit-scrollbar {
  width: 0.5rem;
}
.menu-sider::-webkit-scrollbar-track {
  background: transparent;
}
.menu-sider::-webkit-scrollbar-thumb {
  background: #dcdcdc;
  border-radius: 0.625rem;
}
.menu-sider::-webkit-scrollbar-thumb:hover {
  background: #aeaeae;
}
@media (max-width: 768px) {
  .menu-sider {
    position: fixed;
  }
}
.menu-sider-mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: #00000099;
  z-index: 100;
  transition: 0.3s;
}
.menu-sider-mask.hidden {
  opacity: 0;
  pointer-events: none;
}
.menu-sider-mobile-button {
  position: fixed;
  bottom: 3rem;
  left: -0.4rem;
  z-index: 100;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  box-shadow: 0 0 2px black;
}
@keyframes opacity_entry {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/Sider/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,MAAA;EACA,sBAAA;EAEA,gBAAA;EAEA,gBAAA;EACA,kBAAA;AADF;AAGE;EACE,oBAAA;EACA,UAAA;AADJ;AAZA;EAiBI,aAAA;EACA,sBAAA;EACA,8BAAA;AAFJ;AAjBA;EAuBI,gBAAA;AAHJ;AAKI;EACE,0BAAA;AAHN;AAvBA;EA+BI,UAAA;EACA,+BAAA;EAEA,aAAA;EACA,gBAAA;AANJ;AA7BA;EAsCM,mBAAA;AANN;AAhCA;EA2CI,UAAA;EACA,+BAAA;AARJ;AApCA;EAiDM,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,gBAAA;EACA,qBAAA;EACA,eAAA;AAXN;AA9CA;EA4DQ,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAXR;AApDA;EAmEQ,gBAAA;EACA,cAAA;EACA,gBAAA;EAEA,UAAA;EACA,+BAAA;AAbR;AAgBM;EACE,yBAAA;AAdR;AAaM;EAII,kCAAA;AAdV;AAUM;EAQI,kCAAA;AAfV;AAmBM;EACE,6CAAA;AAjBR;AAgBM;EAII,uCAAA;AAjBV;AAaM;EAQI,uCAAA;AAlBV;AA7EA;EAqGM,cAAA;AArBN;AAhFA;EA0GI,eAAA;AAvBJ;AAnFA;EA6GM,UAAA;EACA,+BAAA;AAvBN;AAvFA;EAiHQ,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAvBR;AA9FA;EAyHQ,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAxBR;AA6BE;EACE,aAAA;AA3BJ;AA8BE;EACE,uBAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,uBAAA;AA7BJ;AAgCE;EACE,mBAAA;AA9BJ;AAiCE;EAAA;IACE,eAAA;EA9BF;AACF;AAiCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;AA/BF;AAiCE;EACE,UAAA;EACA,oBAAA;AA/BJ;AAmCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EAEA,yBAAA;EACA,4BAAA;EAEA,yBAAA;AAnCF;AAsCA;EACE;IACE,UAAA;EApCF;EAsCA;IACE,UAAA;EApCF;AACF","sourcesContent":[".menu-sider {\n  height: 100vh;\n  position: sticky;\n  top: 0;\n  padding-bottom: 1.5rem;\n\n  transition: 0.3s;\n\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  &.hidden {\n    pointer-events: none;\n    opacity: 0;\n  }\n\n  .ant-layout-sider-children {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .menu-sider-button-icon {\n    transition: 0.6s;\n\n    &.expand-icon {\n      transform: rotateY(180deg);\n    }\n  }\n\n  .partner-logo-container {\n    opacity: 1;\n    animation: opacity_entry 0.3s 1;\n\n    display: flex;\n    align-items: end;\n\n    .header-powered-by {\n      margin-left: 0.3rem;\n    }\n  }\n\n  img {\n    opacity: 1;\n    animation: opacity_entry 0.3s 1;\n  }\n\n  .menu-sider-container {\n    .menu-item-container {\n      display: flex;\n      align-items: center;\n      min-width: 2.75rem;\n      min-height: 2.75rem;\n      padding: 0.2rem 0.8rem;\n\n      transition: 0.3s;\n      border-radius: 0.5rem;\n      cursor: pointer;\n\n      .menu-item-icon-container {\n        margin-right: 0.5rem;\n        font-size: 1.2rem;\n        color: #000000;\n        transition: 0.3s;\n      }\n\n      .menu-item-label {\n        font-weight: 500;\n        color: #000000;\n        transition: 0.3s;\n\n        opacity: 1;\n        animation: opacity_entry 0.3s 1;\n      }\n\n      &:hover {\n        background-color: #f2f2f2;\n\n        .menu-item-icon-container {\n          color: var(--primary-button-color);\n        }\n\n        .menu-item-label {\n          color: var(--primary-button-color);\n        }\n      }\n\n      &.active {\n        background-color: var(--primary-button-color);\n\n        .menu-item-icon-container {\n          color: var(--primary-button-text-color);\n        }\n\n        .menu-item-label {\n          color: var(--primary-button-text-color);\n        }\n      }\n    }\n\n    .menu-sider-divider {\n      margin: 1rem 0;\n    }\n  }\n\n  .menu-sider-user-container {\n    cursor: default;\n\n    .user-infos {\n      opacity: 1;\n      animation: opacity_entry 0.3s 1;\n\n      .user-name {\n        font-weight: 500;\n        line-height: 1rem;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .user-business-name {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: #c9d3cc;\n      }\n    }\n  }\n\n  &::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #dcdcdc;\n    border-radius: 0.625rem;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #aeaeae;\n  }\n\n  @media (max-width: @md-screen) {\n    position: fixed;\n  }\n}\n\n.menu-sider-mask {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: #00000099;\n  z-index: 100;\n  transition: 0.3s;\n\n  &.hidden {\n    opacity: 0;\n    pointer-events: none;\n  }\n}\n\n.menu-sider-mobile-button {\n  position: fixed;\n  bottom: 3rem;\n  left: -0.4rem;\n  z-index: 100;\n\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n\n  box-shadow: 0 0 2px black;\n}\n\n@keyframes opacity_entry {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
